import React, { useState, useEffect, useContext, Fragment } from "react";
import { AppContext } from "../Utils/AppContext";
import UserForm from "../Forms/UserForm";
import Page from "../Layout/Page";
import UserTable from "../Tables/UserTable";
import { useGetGlobalSettings, updateDriverThresholdValue } from "../Utils/Company";

const Drivers = () => {
  const context = useContext(AppContext);
  const currentUser = context.state.user;

  const [showUserForm, setShowUserForm] = useState(false);
  const [driverThreshold, setDriverThreshold] = useState("");

  const { globalSettings: globalSettings } = useGetGlobalSettings();

  useEffect(() => {
    if (globalSettings) {
      setDriverThreshold(globalSettings.driverNotificationThreshold);
    }
  }, [globalSettings]);

  return (
    <Page title="Drivers">
      {currentUser.role === "super" && (
        <div>
          <form>
            <label htmlFor="driverThreshold">
              Low energy threshold for driver notifications:
              <input
                type="text"
                name="driverThreshold"
                id="driverThreshold"
                onChange={event => setDriverThreshold(event.target.value)}
                value={driverThreshold}
              />
            </label>
            <br />
            <button onClick={() => updateDriverThresholdValue(driverThreshold)} type="button">
              Update Threshold Values
            </button>
          </form>
          <br />
          <UserTable driverTable hideRole userRole="driver" />
        </div>
      )}

      {currentUser.role === "company-manager" && (
        <UserTable driverTable hideRole hideCompany companyId={currentUser.company.id} userRole="driver" />
      )}

      {currentUser.role === "fleet-manager" && (
        <UserTable
          driverTable
          hideRole
          hideCompany
          companyId={currentUser.company.id}
          userRole="driver"
          fleets={currentUser.managingFleets}
        />
      )}

      {showUserForm && (
        <Fragment>
          <br />
          <UserForm
            cid={currentUser.role !== "super" && currentUser.company.id}
            formComplete={() => {
              setShowUserForm(false);
            }}
          />

          <button
            type="button"
            onClick={() => {
              setShowUserForm(false);
            }}
          >
            Cancel
          </button>
        </Fragment>
      )}

      {!showUserForm && (
        <Fragment>
          <button
            type="button"
            onClick={() => {
              setShowUserForm(true);
            }}
          >
            Add User
          </button>
        </Fragment>
      )}
    </Page>
  );
};

export default Drivers;
